module.exports = __webpack_public_path__ + "img/SES_280258850.d251a47b.jpg";